import axios from "axios";
import apis from "../../../lib/apis/apis";
import { apiHeaders } from "../../../lib/apiHeader";

const unwrap = (response) => {
  if (response?.data?.success === "true") return response.data.data;
  throw new Error(response?.data?.message || "Request failed");
};

// `provider_id` only matters on the Super-Admin settings route, where the
// clinic in the URL isn't the logged-in user. The API ignores it for clinic
// and staff logins, which are always pinned to their own provider.
export const messageTemplatesApi = {
  list: async (params) =>
    unwrap(await axios.get(apis.message_templates, { params, headers: apiHeaders() })),
  create: async (payload) =>
    unwrap(await axios.post(apis.message_templates, payload, { headers: apiHeaders() })),
  update: async (id, payload) =>
    unwrap(
      await axios.post(`${apis.message_templates}/${id}`, payload, {
        headers: apiHeaders(),
      })
    ),
  remove: async (id, params) =>
    unwrap(
      await axios.delete(`${apis.message_templates}/${id}`, {
        params,
        headers: apiHeaders(),
      })
    ),
};
